/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseDataSourceToMerge } from './GetSourceMergePreview200ResponseDataSourceToMerge';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMerge';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseData
 */
export interface GetSourceMergePreview200ResponseData {
    /**
     * 
     */
    source_to_merge: GetSourceMergePreview200ResponseDataSourceToMerge;
    /**
     * 
     */
    merged_source?: GetSourceMergePreview200ResponseDataSourceToMerge;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseData interface.
 */
export function instanceOfGetSourceMergePreview200ResponseData(value: object): value is GetSourceMergePreview200ResponseData {
    if (!('source_to_merge' in value) || value['source_to_merge'] === undefined) return false;
    return true;
}

export function GetSourceMergePreview200ResponseDataFromJSON(json: any): GetSourceMergePreview200ResponseData {
    return GetSourceMergePreview200ResponseDataFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'source_to_merge': GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json['source_to_merge']),
        'merged_source': json['merged_source'] == null ? undefined : GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json['merged_source']),
    };
}

export function GetSourceMergePreview200ResponseDataToJSON(json: any): GetSourceMergePreview200ResponseData {
    return GetSourceMergePreview200ResponseDataToJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataToJSONTyped(value?: GetSourceMergePreview200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_to_merge': GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value['source_to_merge']),
        'merged_source': GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value['merged_source']),
    };
}

